import styled from "styled-components";

export const DetailsContainer = styled.div`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 10px;
  padding: 0.5rem;
`;

export const DetailsHeader = styled.div`
  background-color: rgba(231, 231, 234, 0.62);

  border-radius: 10px;
  display: grid;
  grid-template-columns: 9fr 2fr 2fr 2fr 2fr 2fr 2fr 0.5fr;
  font-size: 1.2rem;
  font-weight: 700;
  padding: 1rem 1.5rem;

  .discount {
    color: ${(props) => props.theme.colors.accentRed};
  }
  .selling-price {
    font-weight: 700;
  }
`;
